/**
 * Long-Press (Touch) = Rechtsklick-Ersatz für iPad/iPhone (Iter 351n).
 *
 * Ohne Hooks, damit es auch in .map()-Schleifen (Kalender-Zellen) nutzbar
 * ist — Timer/Startposition werden am DOM-Node selbst gehalten.
 *
 * Verhalten: 500ms gedrückt halten ohne Bewegung (>12px bricht ab, z.B.
 * beim Scrollen) → callback({ clientX, clientY }). Der nachfolgende
 * synthetische Click wird unterdrückt.
 */
const DELAY_MS = 500;
const MOVE_TOLERANCE_PX = 12;

const clearTimer = (node) => {
  if (node && node._lpTimer) {
    clearTimeout(node._lpTimer);
    node._lpTimer = null;
  }
};

export const longPressHandlers = (callback, { stopPropagation = false } = {}) => ({
  onTouchStart: (e) => {
    if (stopPropagation) e.stopPropagation();
    const t = e.touches && e.touches[0];
    if (!t) return;
    const node = e.currentTarget;
    node._lpStart = { x: t.clientX, y: t.clientY };
    node._lpFired = false;
    clearTimer(node);
    node._lpTimer = setTimeout(() => {
      node._lpTimer = null;
      node._lpFired = true;
      callback({ clientX: node._lpStart.x, clientY: node._lpStart.y });
    }, DELAY_MS);
  },
  onTouchMove: (e) => {
    const node = e.currentTarget;
    if (!node._lpTimer || !node._lpStart) return;
    const t = e.touches && e.touches[0];
    if (!t) return;
    if (
      Math.abs(t.clientX - node._lpStart.x) > MOVE_TOLERANCE_PX ||
      Math.abs(t.clientY - node._lpStart.y) > MOVE_TOLERANCE_PX
    ) {
      clearTimer(node);
    }
  },
  onTouchEnd: (e) => {
    if (stopPropagation) e.stopPropagation();
    const node = e.currentTarget;
    clearTimer(node);
    if (node._lpFired) {
      node._lpFired = false;
      // Kein Click-Event nach erfolgreichem Long-Press
      if (e.cancelable) e.preventDefault();
    }
  },
  onTouchCancel: (e) => clearTimer(e.currentTarget),
});
